import useCollectionData from "astrid-firestore/src/hooks/useCollectionData";

import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";

import ArtifactManager from "../../components/ArtifactManager/ArtifactManager";

export default function ArtifactFilesView({ artifact, disabled }) {
	const [files, loading, error] = useCollectionData(artifact.ref.collection("files"));

	return (
		<LoadingContext loading={loading} error={error}>
			<ArtifactManager files={files} artifact={artifact} disabled={disabled} />
		</LoadingContext>
	);
}
